import { render, staticRenderFns } from "./textcolor.vue?vue&type=template&id=073b6bda"
import script from "./textcolor.vue?vue&type=script&lang=js"
export * from "./textcolor.vue?vue&type=script&lang=js"
import style0 from "./textcolor.vue?vue&type=style&index=0&id=073b6bda&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073b6bda')) {
      api.createRecord('073b6bda', component.options)
    } else {
      api.reload('073b6bda', component.options)
    }
    module.hot.accept("./textcolor.vue?vue&type=template&id=073b6bda", function () {
      api.rerender('073b6bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/textcolor.vue"
export default component.exports